import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HlDisplayAvailabilityReportService {
  constructor(protected http: HttpClient) {}

  public getAvailabilityReport(productId: string): Observable<HLDisplayAvailabilityReport> {
    const headers = {
      maxAge: '-1'
    };
    const url = `json/hl-display/availability-report/${productId}`;
    return this.http.get<HLDisplayAvailabilityReport>(url, { headers: headers });
  }
}

export interface HLDisplayAvailabilityReport {
  entries: HLDisplayAvailabilityReportEntry[];
  stockAvailabilities: HLDisplayAvailabilityPerStock[];
}

export interface HLDisplayAvailabilityReportEntry {
  arrivalDate: string;
  availableQuantity: number;
  stockId: string;
  type: string;
  availableFromStock: number;
}

export interface HLDisplayAvailabilityPerStock {
  stockId: string;
  stockName: string;
  availableQuantity: number;
}
